export default "__VITE_ASSET__bemmGG9S__"